export default __webpack_public_path__ + "img/eye.d1a0df5e.svg";